import React, { useEffect, useState, } from 'react'
import { Modal } from 'react-bootstrap';
import HtmlParser from 'react-html-parser';

import axios from 'axios';

import {
    responseGet, globalSettings, setBadgeStatusGeneric, numberSet, separatorsNumbersSet, styles, validateDecimals, sendMessageCloseCurrentWindowAsync,
    buttonProcessGet, dateTimeFormatGlobalSet, languageObjGet, isUndNullEmp, awaitDelay, lodash,
} from '../../helpers/settings';
import { receiptModelGet } from '../../models/receipts/receipt';
import { apartmentReceiptDetailModelGet } from '../../models/apartments/apartmentReceiptDetail';
import { apartmentModelGet } from '../../models/apartments/apartment';
import { apartmentReceiptModelGet } from '../../models/apartments/apartmentReceipt';
import { GlobalFormats } from '../../classes/main/globalFormats';

const neutralValue = 0.00;
const currentMethod = 'ReceiptPerApartmentDetailAdd';

export default function ReceiptPerApartmentDetailAdd({
    $ = {},
    auth = {},
    buildingBalance = neutralValue,
    setBuildingBalance = () => { },
    buildingBalanceSetAsync = async ({ balance = neutralValue, subMethod = '', }) => { },
    receipt = receiptModelGet({}),
    apartmentReceiptDetail = { ...apartmentReceiptDetailModelGet({}), description: '', },
    setApartmentReceiptDetail = () => { },
    dtApartemReceiptDetailRowIndex = 0,
    apartment = apartmentModelGet({}),
    apartmentBalance = neutralValue,
    setApartmentBalance = () => { },
    apartmentReceipt = apartmentReceiptModelGet({}),
    setApartmentReceipt = () => { },
    dtApartmentsId = '',
    dtApartmentsRowIndex = 0,
    dtReceiptsId = '',
    dtReceiptsRowIndex = 0,
    dtReceiptId = '',
    showModal = false,
    setShowModal = () => { },
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region variables
    let result;
    let dataObj = {};
    let headerObj = {};
    const [priceError, setPriceError] = useState('');
    const [quantityError, setQuantityError] = useState('');
    const neutralValueStr = separatorsNumbersSet({ number: neutralValue, withDecimals: true, consoleLogErrorShow: true, subMethod: currentMethod, })?.result;
    //#region others
    const controls = {
        buttons: {
            save: {
                id: 'btnApartmentReceiptDetailEditSave',
                className: 'btn btn-outline-warning',
            },
            back: {
                id: 'btnApartmentReceiptDetailEditBack',
                className: 'btn btn-outline-success mx-1',
            },
            close: {
                id: 'btnApartmentReceiptDetailEditClose',
                className: 'close btn-danger fas fa-window-close',
            },
        },
        inputs: {
            quantity: {
                id: 'inputApartmentReceiptDetailEditQuantity',
                className: 'form-control text-right',
            },
            price: {
                id: 'inputApartmentReceiptDetailEditPrice',
                className: 'form-control text-right',
            },
        },
        dataTables: {
            // apartmentReceiptDetails: {
            //     buttons: {
            //         // create: {
            //         //     className: 'btn btn-outline-success float-right btn-sm',
            //         //     id: 'btnDtExpenseConceptsCreate',
            //         // },
            //     },
            //     icons: {
            //         // create: {
            //         //     id: 'iconDtExpenseConceptsCreate',
            //         //     className: globalSettings?.icons?.plusCircle,
            //         // },
            //     },
            //     inputs: {
            //         search: {
            //             id: `${dtReceiptId}_filter input`,
            //             className: '',
            //         },
            //     },
            //     selects: {
            //         entries: {
            //             id: `${dtReceiptId}_length select`,
            //             className: '',
            //         },
            //     },
            //     spinners: {
            //         // create: {
            //         //     id: 'spDtExpenseConceptsCreate',
            //         //     className: '',
            //         // },
            //     },
            // },
        },
        icons: {
            save: {
                id: 'icoApartmentReceiptDetailEditSave',
                className: globalSettings?.icons?.save,
            },
            back: {
                id: 'icoApartmentReceiptDetailEditBack',
                className: globalSettings?.icons?.arrowAltCircleLeft,
            },
            close: {
                id: 'icoApartmentReceiptDetailEditClose',
                className: globalSettings?.icons?.print,
            },
        },
        spinners: {
            save: {
                id: 'spApartmentReceiptDetailEditSave',
                className: '',
            },
            back: {
                id: 'spApartmentReceiptDetailEditBack',
                className: '',
            },
            close: {
                id: 'spApartmentReceiptDetailEditClose',
                className: '',
            },
        },
    };
    //#endregion others
    //#endregion variables

    //#region apartmentReceipDetail (methods)
    const receiptApartmentEditDetailPostAsync = async ({
        e = {},
        subMethod = '',
    }) => {
        const currentMethod = 'receiptApartmentEditDetailPostAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region variables
            let dtRowObj = {};
            let conceptTotalLocal = neutralValue;
            let buildingBalanceLocal = neutralValue;
            let apartmentBalanceLocal = neutralValue;
            let buildingBalanceTotalLocal = neutralValue;
            let apartmentReceiptTotalLocal = neutralValue;
            let apartmentBalanceTotalLocal = neutralValue;
            let conceptTotalBeforeEditLocal = neutralValue;
            let apartmentReceiptBalanceLocal = neutralValue;
            let descriptionLocal = apartmentReceiptDetail?.description;
            //#endregion variables

            //#region initialize
            response = await validateFormDataAsync({
                subMethod: currentMethod,
            });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion initialize

            controlsStatusSet({ processType: 1, subMethod: currentMethod, });

            //#region update data (apartment receipt detail)
            if (lodash?.hasIn({ obj: apartmentReceiptDetail, data: globalSettings?.collections?.properties?.description, subMethod: currentMethod, })?.result) {
                delete apartmentReceiptDetail?.description;
            }

            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };

            dataObj = {
                languageId: languageObj?.id,
                apartmentReceiptDetail: apartmentReceiptDetail,
                url: `${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlApartmentReceiptDetails}/${apartmentReceiptDetail?.id}`,
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj,
            );

            response = result?.data || {};

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            apartmentReceiptDetail = response?.result?.apartmentReceiptDetail || {};
            conceptTotalBeforeEditLocal = response?.result?.conceptTotalBeforeEdit || {};
            conceptTotalLocal = response?.result?.conceptTotal || neutralValue;
            apartmentReceiptBalanceLocal = response?.result?.apartmentReceiptBalance || neutralValue;
            apartmentReceiptTotalLocal = response?.result?.apartmentReceiptTotal || neutralValue;
            setApartmentReceipt({
                ...apartmentReceipt,
                [globalSettings?.collections?.properties?.balance]: apartmentReceiptBalanceLocal,
                [globalSettings?.collections?.properties?.total]: apartmentReceiptTotalLocal,
            });
            //#endregion update data apartment receipt detail)

            //#region update record to dtReceipt
            //#region variables
            dtRowObj = {
                description: descriptionLocal,
                quantity: separatorsNumbersSet({
                    number: apartmentReceiptDetail?.quantity,
                    withDecimals: true,
                    consoleLogErrorShow: true,
                    subMethod: currentMethod,
                })?.result,
                price: separatorsNumbersSet({
                    number: apartmentReceiptDetail?.price,
                    withDecimals: true,
                    consoleLogErrorShow: true,
                    subMethod: currentMethod,
                })?.result,
                conceptTotal: separatorsNumbersSet({
                    number: conceptTotalLocal,
                    withDecimals: true,
                    consoleLogErrorShow: true,
                    subMethod: currentMethod,
                })?.result,
            }
            //#endregion variables

            //#region methods
            $(`#${dtReceiptId}`)?.DataTable()?.row(dtApartemReceiptDetailRowIndex)?.data?.([
                dtRowObj?.description,
                dtRowObj?.quantity,
                dtRowObj?.price,
                dtRowObj?.conceptTotal,
                buttonProcessGet({
                    id: apartmentReceiptDetail?.id,
                    description: dtRowObj?.description,
                    showDetails: false,
                    labelDetails: globalSettings?.labels?.detail?.[languageObj?.id],
                    enabledDetails: false,
                    showEdit: true,
                    labelEdit: globalSettings?.labels?.edit?.[languageObj?.id],
                    enabledEdit: true,
                    showDelete: true,
                    labelDelete: globalSettings?.labels?.delete?.[languageObj?.id],
                    enabledDelete: true,
                    processButtons: [],
                    subMethod: currentMethod,
                })?.result,
            ])?.draw(true);
            //#endregion methods
            //#endregion update record to dtReceipt

            //#region update record dtReceipts
            //#region variables
            dtRowObj = {
                receiptNumberApartment: apartmentReceipt?.receiptNumberApartment,
                from: dateTimeFormatGlobalSet({
                    date: receipt?.from,
                    type: languageObj?.format?.date?.f1,
                    format: 0,
                    addTime: false,
                    secondsShow: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result,
                total: separatorsNumbersSet({
                    number: apartmentReceiptTotalLocal,
                    withDecimals: true,
                    consoleLogErrorShow: true,
                    subMethod: currentMethod,
                })?.result,
                status: setBadgeStatusGeneric({
                    type: apartmentReceiptBalanceLocal > neutralValue ? 1 : 0,
                    value: separatorsNumbersSet({
                        number: apartmentReceiptBalanceLocal,
                        withDecimals: true,
                        consoleLogErrorShow: true,
                        subMethod: currentMethod,
                    })?.result,
                }),
            };
            //#endregion variables

            //#region methods
            $(`#${dtReceiptsId}`)?.DataTable()?.row(dtReceiptsRowIndex)?.data?.([
                dtRowObj?.receiptNumberApartment,
                dtRowObj?.from,
                dtRowObj?.total,
                dtRowObj?.status,
                buttonProcessGet({
                    id: apartmentReceipt?.id,
                    description: apartment?.identifier,
                    showDetails: true,
                    labelDetails: globalSettings?.labels?.receiptDetail?.[languageObj?.id],
                    enabledDetails: true,
                    showEdit: false,
                    labelEdit: globalSettings?.labels?.edit?.[languageObj?.id],
                    enabledEdit: false,
                    showDelete: false,
                    labelDelete: globalSettings?.labels?.delete?.[languageObj?.id],
                    enabledDelete: false,
                    processButtons: [],
                    subMethod: currentMethod,
                })?.result,
            ])?.draw(true);
            //#endregion methods

            apartmentBalanceLocal = numberSet({
                number: apartmentBalance,
                type: 'd',
                languageId: languageObj?.id,
                subMethod: currentMethod,
            })?.result;
            apartmentBalanceTotalLocal = numberSet({
                number: ((apartmentBalanceLocal + conceptTotalBeforeEditLocal) + conceptTotalLocal),
                type: 'd',
                languageId: languageObj?.id,
                subMethod: currentMethod,
            })?.result;
            setApartmentBalance(apartmentBalanceTotalLocal);
            //#endregion update record dtReceipts

            //#region update record dtApartments
            //#region variables
            dtRowObj = {
                floor: apartment?.floor,
                identifier: apartment?.identifier,
                balance: separatorsNumbersSet({
                    number: apartmentBalanceTotalLocal,
                    withDecimals: true,
                    consoleLogErrorShow: true,
                    subMethod: currentMethod,
                })?.result,
            };
            //#endregion variables

            //#region methods
            $(`#${dtApartmentsId}`)?.DataTable()?.row(dtApartmentsRowIndex)?.data?.([
                dtRowObj?.floor,
                dtRowObj?.identifier,
                dtRowObj?.balance,
                buttonProcessGet({
                    id: apartment?.id,
                    description: dtRowObj?.identifier,
                    showDetails: true,
                    labelDetails: globalSettings?.labels?.viewReceipts?.[languageObj?.id],
                    enabledDetails: true,
                    showEdit: false,
                    labelEdit: globalSettings?.labels?.edit?.[languageObj?.id],
                    enabledEdit: false,
                    showDelete: false,
                    labelDelete: globalSettings?.labels?.delete?.[languageObj?.id],
                    enabledDelete: false,
                    processButtons: [],
                    subMethod: currentMethod,
                })?.result,
            ])?.draw(true);
            //#endregion methods
            //#endregion update record dtApartments

            //#region update building balance
            buildingBalanceLocal = numberSet({
                number: buildingBalance,
                type: 'd',
                languageId: languageObj?.id,
                subMethod: currentMethod,
            })?.result;
            buildingBalanceTotalLocal = numberSet({
                number: ((buildingBalanceLocal + conceptTotalBeforeEditLocal) + conceptTotalLocal),
                type: 'd',
                languageId: languageObj?.id,
                subMethod: currentMethod,
            })?.result;
            setBuildingBalance(buildingBalanceTotalLocal);

            response = await buildingBalanceSetAsync({
                balance: buildingBalanceTotalLocal,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                return;
            }
            //#endregion update building balance

            await defaultValueSetAsync({
                isModalClose: true,
                subMethod: currentMethod,
            });

            await sendMessageCloseCurrentWindowAsync({
                msgType: 0,
                msgText: globalSettings?.messages?.processesCompletedSuccessfully?.[languageObj?.id],
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }
    //#endregion apartmentReceiptDetail (methods)

    //#region methods (others)
    const formValeSetAsync = async ({
        key = '',
        value = '',
        subMethod = '',
    }) => {
        const currentMethod = 'formValeSetAsync';
        let response = responseGet();
        try {
            setApartmentReceiptDetail({ ...apartmentReceiptDetail, [key]: value, });
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const defaultValueSetAsync = async ({
        isModalClose = false,
        subMethod = '',
    }) => {
        const currentMethod = 'defaultValueSetAsync';
        let response = responseGet();
        try {
            //#region body show modal set
            if (isModalClose) {
                setPriceError('');
                setQuantityError('');
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                controlsStatusSet({ processType: 2, subMethod: currentMethod, });
                await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            }
            //#endregion body show modal set

            setShowModal(!isModalClose);
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const validateFormDataAsync = async ({
        subMethod = '', }) => {
        const currentMethod = 'validateFormDataAsync';
        let response = responseGet();
        try {
            //#region methods
            apartmentReceiptDetail.quantity = numberSet({
                number: apartmentReceiptDetail?.quantity,
                type: 'd',
                languageId: languageObj?.id,
                subMethod: currentMethod,
            })?.result;
            apartmentReceiptDetail.price = numberSet({
                number: apartmentReceiptDetail?.price,
                type: 'd',
                languageId: languageObj?.id,
                subMethod: currentMethod,
            })?.result;

            if (apartmentReceiptDetail?.quantity <= neutralValue) {
                setQuantityError(`${globalSettings?.messages?.mustBeGreaterThan?.[languageObj?.id]} <b>${neutralValueStr}</b>`);
                response.isWarning = true;
            }

            if (apartmentReceiptDetail?.price <= neutralValue) {
                setPriceError(`${globalSettings?.messages?.mustBeGreaterThan?.[languageObj?.id]} <b>${neutralValueStr}</b>`);
                response.isWarning = true;
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const controlsStatusSet = ({ processType = 0, subMethod = '', }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    for (let ctrStr in controls) {
                        const objStr = ['buttons', 'spinners', 'icons'];
                        if (objStr?.includes(ctrStr)) {
                            for (let propStr in controls?.[ctrStr]) {
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.removeClass();
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.addClass(controls?.[ctrStr]?.[propStr]?.className);
                            }
                        }
                    }
                    break;
                case 1:
                    $(`#${controls?.icons?.save?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.save?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                case 2:
                    $(`#${controls?.icons?.back?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.back?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                default:
                    break;
            }

            //#region controls
            $(`#${controls?.inputs?.quantity?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.inputs?.price?.id}`)?.attr('readOnly', (processType !== 0));
            // $(`#${controls?.inputs?.expenseTemplateTotal?.id}`)?.attr('readOnly', (processType !== 0));
            //#endregion controls

            //#region url (register / passwords)
            // $(`#${controls?.urls?.forgotYourPassword?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlForgotPassword));
            // $(`#${controls?.urls?.userRegister?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlUserRegister));
            // $(`#${controls?.urls?.registerStatus?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlRegisterStatus));
            //#endregion url (register / passwords)

            //#region url (rechaptcha)
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.react?.reCAPTCHA?.urlPrivaciConditions));
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('target', (processType !== 0 ? '' : '_blank'));
            //#endregion url (rechaptcha)

            //#region urls
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr({
            //     'href': (processType !== 0 ? urlStop : globalSettings?.app?.reCAPTCHA?.urlPrivaciConditions),
            //     'target': (processType !== 0 ? '' : '_blank'),
            // });
            //#endregion urls

            //#region dataTable buttons
            // btnExcel.node.disabled = processType !== 0;
            // btnPdf.node.disabled = processType !== 0;
            //#endregion dataTable buttons

            //#region dataTable
            // $(`#${controls?.dataTables?.apartmentReceiptDetails?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0 && processType <= 2));
            // $(`#${controls?.dataTables?.apartmentReceiptDetails?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0 && processType <= 2));

            // $(`#${controls?.dataTables?.expenseConcepts?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0));
            // $(`#${controls?.dataTables?.expenseConcepts?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0));
            //#endregion dataTable

            if (processType !== 0) {
                $(`#${controls?.buttons?.save?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
                $(`#${controls?.buttons?.back?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
                $(`#${controls?.buttons?.close?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console?.error(response);
        }
        return response;
    }

    useEffect(() => {
        //console?.log(showModal);
    }, [showModal]);
    //#endregion methods (others)

    return (
        <Modal backdrop='static' show={showModal} onHide={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - onHide', })}>
            <Modal.Header>
                <Modal.Title>
                    <img alt={globalSettings?.labels?.concept?.[languageObj?.id]}
                        src={globalSettings?.images?.expenseConceptsLogo}
                        style={styles?.cardHeaderLogo}>
                    </img> - {globalSettings?.labels?.edit?.[languageObj?.id]}
                </Modal.Title>
                <button id={controls?.buttons?.close?.id}
                    className={controls?.buttons?.close?.className}
                    type='button'
                    data-dismiss='modal'
                    aria-label='Close' onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - btnClose', })}>
                </button>
            </Modal.Header>

            <form onSubmit={(e) => receiptApartmentEditDetailPostAsync({ e: e, subMethod: 'form - onSubmit', })}>
                <Modal.Body>
                    {/* <form onSubmit={(e) => receiptApartmentEditDetailPostAsync(e)}> */}

                    <div className='row '>
                        <div className='col-md-6'>
                            <div className='form-group'>
                                <ul className='list-unstyled text-muted'>
                                    <li>{globalSettings?.labels?.concept?.[languageObj?.id]}: <b>{apartmentReceiptDetail?.description || ''}</b>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className='form-group'>
                                <ul className='list-unstyled text-muted text-right'>
                                    <li>{globalSettings?.labels?.subTotal?.[languageObj?.id]}:  {
                                        HtmlParser(
                                            setBadgeStatusGeneric({
                                                type: 1,
                                                value: separatorsNumbersSet({
                                                    number: numberSet({
                                                        number: ((apartmentReceiptDetail?.quantity || neutralValue) * (apartmentReceiptDetail?.price || neutralValue)),
                                                        type: 'd',
                                                        languageId: languageObj?.id,
                                                        subMethod: 'lbl - subTotal',
                                                    })?.result,
                                                    withDecimals: true,
                                                    consoleLogErrorShow: true,
                                                    subMethod: 'lbl - subTotal',
                                                })?.result,
                                                subMethod: 'lbl - subTotal',
                                            })
                                        )
                                    }
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className='row'>
                        <div className='col-md-6'>
                            <div className='form-group'>
                                <div className='input-group mb-3'>
                                    <input id={controls?.inputs?.quantity?.id}
                                        className={controls?.inputs?.quantity?.className}
                                        //autoFocus
                                        onChange={(e) => formValeSetAsync({
                                            key: globalSettings?.collections?.properties?.quantity,
                                            value: validateDecimals({ e: e, languageId: languageObj?.id, subMethod: 'input - quantity', }),
                                            subMethod: 'input - quantity',
                                        })}
                                        onFocus={() => setQuantityError('')}
                                        placeholder={globalSettings?.labels?.quantity?.[languageObj?.id]}
                                        tooltip='tooltip'
                                        title={globalSettings?.labels?.quantity?.[languageObj?.id]}
                                        value={apartmentReceiptDetail?.quantity || '0.00'} />
                                    <div className='input-group-append'>
                                        <div className='input-group-text'>
                                            <span className={globalSettings?.icons?.sortNumericUpAlt} />
                                        </div>
                                    </div>
                                </div>
                                <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(quantityError)}</div>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className='form-group'>
                                <div className='input-group mb-3'>
                                    <input id={controls?.inputs?.price?.id}
                                        className={controls?.inputs?.price?.className}
                                        onChange={(e) => formValeSetAsync({
                                            key: globalSettings?.collections?.properties?.price,
                                            value: validateDecimals({ e: e, languageId: languageObj?.id, subMethod: 'input - price', }),
                                            subMethod: 'input - price',
                                        })}
                                        onFocus={() => setPriceError('')}
                                        placeholder={globalSettings?.labels?.price?.[languageObj?.id]}
                                        tooltip='tooltip'
                                        title={globalSettings?.labels?.price?.[languageObj?.id]}
                                        value={apartmentReceiptDetail?.price || '0.00'} />
                                    <div className='input-group-append'>
                                        <div className='input-group-text'>
                                            <span className={globalSettings?.icons?.moneyBillWave} />
                                        </div>
                                    </div>
                                </div>
                                <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(priceError)}</div>
                            </div>
                        </div>
                    </div>

                    {/* <div className='form-group text-right'>
                        <button className='btn btn-outline-warning'
                            tooltip='tooltip'
                            title={globalSettings?.labels?.save?.[languageObj?.id]}
                            type='submit'>
                            <i className={globalSettings?.icons?.save}></i>
                        </button>
                        <button className='btn btn-outline-success mx-1'
                            tooltip='tooltip'
                            title={globalSettings?.labels?.close?.[languageObj?.id]}
                            type='reset'
                            onClick={() => defaultValueSetAsync(true)}>
                            <i className={globalSettings?.icons?.arrowAltCircleLeft}></i>
                        </button>
                    </div> */}

                    {/* </form> */}
                </Modal.Body>

                <Modal.Footer>
                    <button id={controls?.buttons?.save?.id}
                        className={controls?.buttons?.save?.className}
                        tooltip='tooltip'
                        title={globalSettings?.labels?.save?.[languageObj?.id]}
                        type='submit'>
                        <i id={controls?.icons?.save?.id} className={controls?.icons?.save?.className} /> <span id={controls?.spinners?.save?.id} className='' aria-hidden='true'></span>
                    </button>
                    <button id={controls?.buttons?.back?.id}
                        className={controls?.buttons?.back?.className}
                        tooltip='tooltip'
                        title={globalSettings?.labels?.close?.[languageObj?.id]}
                        type='button'
                        onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - btnBack', })}>
                        <i id={controls?.icons?.back?.id} className={controls?.icons?.back?.className} /> <span id={controls?.spinners?.back?.id} className='' aria-hidden='true'></span>
                    </button>
                </Modal.Footer>
            </form>
        </Modal>
    )
}